<ng-container *transloco="let t">
  @if (embedded()) {
    <ng-container *ngTemplateOutlet="modalCard; context: { $implicit: t }" />
  } @else {
    <div
      id="base-modal-backdrop"
      class="fixed inset-0 bg-black/50 flex items-center justify-center p-4 safe-area-bottom"
      [class.z-60]="!critical()"
      [class.z-critical]="critical()"
      tabindex="-1"
      (click)="onBackdropClick($event)"
      (keydown)="onKeydown($event)"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="shouldAutoCaptureFocus()"
    >
      <ng-container *ngTemplateOutlet="modalCard; context: { $implicit: t }" />
    </div>
  }

  <ng-template #modalCard let-t>
    <div
      id="base-modal-container"
      class="bg-white rounded-modal shadow-modal flex flex-col overflow-hidden"
      [class.w-full]="size() !== 'fit'"
      [class.w-auto]="size() === 'fit'"
      [class.max-h-[90vh]]="!embedded()"
      [class.max-h-[85vh]]="embedded()"
      [class.max-w-[800px]]="size() === 'large' && !customMaxWidth()"
      [class.max-w-[480px]]="size() === 'medium' && !customMaxWidth()"
      [class.max-w-[90vw]]="size() === 'fit' && !customMaxWidth()"
      [style.max-width]="customMaxWidth() ?? null"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="ariaLabelledBy()"
    >
      <header
        id="base-modal-header"
        class="flex items-center justify-between gap-6 px-6 py-4 shrink-0"
        [class.border-b]="!headerIcon()"
        [class.border-ld-border]="!headerIcon()"
      >
        @if (headerImage()) {
          <img [src]="headerImage()" [alt]="title()" class="max-h-[72px] w-auto" />
          <h2 [id]="ariaLabelledBy()" class="sr-only">{{ title() }}</h2>
        } @else {
          <h2
            [id]="ariaLabelledBy()"
            class="text-xl font-dm font-medium text-ld-neutral leading-7 m-0 flex items-center gap-2"
          >
            <ng-content select="[modal-header-prefix]"></ng-content>
            @if (headerIcon()) {
              <mat-icon [class]="headerIconClass() ?? ''" [style.color]="headerIconColor()" aria-hidden="true">
                {{ headerIcon() }}
              </mat-icon>
            }
            {{ title() }}
          </h2>
        }
        @if (showCloseButton()) {
          <button
            id="base-modal-close-btn"
            type="button"
            class="flex items-center justify-center w-8 h-8 rounded-full bg-transparent border-0 cursor-pointer hover:bg-ld-neutral-100 transition-colors focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2"
            [attr.aria-label]="t('commonAriaClose')"
            [disabled]="isLoading()"
            (click)="onClose()"
          >
            <span class="text-ld-neutral-500 text-base leading-none" aria-hidden="true">✕</span>
          </button>
        }
      </header>

      <div
        id="base-modal-content"
        class="flex-1 overflow-y-auto p-6 text-left"
        [class.overflow-x-hidden]="size() === 'large'"
      >
        <ng-content select="[modal-content]"></ng-content>
      </div>

      <footer
        id="base-modal-footer"
        class="px-6 py-6 border-t border-ld-border shrink-0"
        [class.border-t]="size() === 'large'"
        [class.border-t-0]="size() === 'medium'"
        [class.pt-0]="size() === 'medium'"
      >
        <div id="base-modal-footer-buttons" class="w-full">
          <ng-content select="[modal-footer]"></ng-content>
        </div>
      </footer>
    </div>
  </ng-template>
</ng-container>
